import axios from "axios";
import type {
  ListPrescriptionRefillsRequestProto,
  ListPrescriptionRefillsResponseProto,
} from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/prescription_refill_service";
import type { PrescriptionRefillProto } from "@noom/noom-contracts/noom_contracts/healthcare/model/prescription_refill";

import { HEALTHCARE_API } from "@modules/common/constants";

export type { PrescriptionRefillProto };

export const listPrescriptionRefills = async (
  request: ListPrescriptionRefillsRequestProto,
  accessToken: string
): Promise<PrescriptionRefillProto[]> => {
  const { accessCode } = request;
  const response = await axios.get<ListPrescriptionRefillsResponseProto>(
    `${HEALTHCARE_API}/v1/patient/${accessCode}/prescription_refills`,
    {
      headers: {
        Authorization: `bearer ${accessToken}`,
      },
    }
  );
  return response.data.prescriptionRefills ?? [];
};
